var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "attach-image-container",
    class: _vm.computedClasses
  }, [_vm.link ? [_vm.uploadType === 'image' ? [_c('div', {
    staticClass: "attach-image-view",
    style: {
      backgroundImage: "url(".concat(_vm.link, ")")
    },
    on: {
      "click": _vm.onClickToImage
    }
  }), _c('button', {
    staticClass: "attach-remove-button",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onResetImage($event);
      }
    }
  }, [_c('i', {
    staticClass: "attach-remove-icon"
  })])] : [_c('button', {
    staticClass: "attach-image-label attach-image-label-reset",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onResetImage($event);
      }
    }
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_trash"
    }
  })], 1)]] : _vm.loading ? [_c('div', {
    staticClass: "attach-image-spinner"
  }, [_c('cs-spinner')], 1)] : [_c('label', {
    staticClass: "attach-image-label",
    class: {
      'attach-image-label-ticket': _vm.uploadType === 'ticket'
    },
    attrs: {
      "for": _vm.inputId
    }
  })], _c('input', {
    ref: "files",
    attrs: {
      "id": _vm.inputId,
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.onChangeImage
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }